import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { useState } from "react";
import { IGetServiceProps } from "@api/types/globalService.types";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import URLS from "@api/constants/urls";

export const useBrokerLandingPageService = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
}: IGetServiceProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);
  const allBrokerLandingPageService = useQuery({
    queryKey: [...CACHE_KEYS.LANDING_PAGE, page, per_page, debouncedQuery],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.BROKER_LANDING_PAGE,
        searchParams: {
          "filter[name]": debouncedQuery,
          page: page,
          per_page: per_page,
          include: "journeys,journeys.segment,journey_type",
        },
      }),
    enabled: enableQuery,
  });

  return {
    services: { allBrokerLandingPageService },
    states: { searchQuery, setSearchQuery },
  };
};
